import * as logo from '@/assets/logo.png'

export default {
  title: 'Pluma CMS',
  tagline: 'CMS, intuitively',
  logo: logo,

  dark: false,
}
